import React, { useEffect, useState } from 'react';
import { default as List } from '@material-ui/core/List';
import DeletionDialog from '../../../components/dialogs/DeletionDialog';
import { IReport } from '../../../state/types';
import { customAction } from '../../../state/_actions';
import { useAppDispatch } from '../../../hooks';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    report: IReport;
    afterItemDelete?: () => void;
    expandedReports?: { [key: string]: boolean };
    renderReportList: (params: {
        open: boolean;
        handleExpandClick: () => void;
        openDeletionDialog: (id: string, message?: string) => void;
    }) => React.ReactNode;

    onExpand?: () => void;
}

const Report = ({
    report,
    expandedReports,
    afterItemDelete,
    renderReportList,
    onExpand,
}: IOwnProps) => {
    const dispatch = useAppDispatch();
    const classes = useStyles();
    const [open, setOpen] = useState(!!report._meta?.expanded);
    const [isDeletionDialogOpen, setIsDeletionDialogOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState<string | null>(null);
    const [deleteMessage, setDeleteMessage] = useState<string | undefined>(
        undefined
    );

    const hasDeleteAction = !!report._meta?.actions?.delete;

    useEffect(() => {
        if (expandedReports?.[report.label] !== undefined) {
            setOpen(!expandedReports[report.label]);
        } else {
            setOpen((report._meta && report._meta.expanded) || false);
        }
    }, []);

    const handleExpandClick = () => {
        setOpen((prev) => !prev);
        onExpand?.();
    };

    const openDeletionDialog = (id: string, message?: string) => {
        setIsDeletionDialogOpen(true);
        setIdToDelete(id);
        setDeleteMessage(message);
    };

    const closeDeletionDialog = () => {
        setIsDeletionDialogOpen(false);
        setIdToDelete(null);
    };

    const handleDeleteAction = () => {
        const deleteAction = report._meta?.actions?.delete;
        if (!deleteAction) return;

        const action = {
            ...deleteAction,
            params: { ...deleteAction.params, id: idToDelete || '' },
        };

        dispatch(customAction(action, undefined, afterItemDelete));
    };

    return (
        <List component="nav" disablePadding className={classes.list}>
            {renderReportList({
                open,
                handleExpandClick,
                openDeletionDialog,
            })}

            {hasDeleteAction && (
                <DeletionDialog
                    isOpen={isDeletionDialogOpen}
                    close={closeDeletionDialog}
                    confirm={() => {
                        handleDeleteAction();
                        closeDeletionDialog();
                    }}
                    title="Removal confirmation"
                    message={deleteMessage || 'Are you sure?'}
                />
            )}
        </List>
    );
};

export default Report;
